import { Component, EventEmitter, HostListener, Input, Output, ViewEncapsulation } from '@angular/core';
import { FiltersService } from '../../../services/filters.service';
import { DistributionDataService } from '../../../services/distributionData.service';
import { PoolingPortalService } from '../../../services/pooling-portal.service';
import { Filters } from '../../../interface/scrubber.interface';
import { Subscription } from 'rxjs';
import { LngDataService } from 'src/app/services/lng.service';
import { AvgBunkerPriceData, Lng } from 'src/app/interface/lng.interface';
import { GoogleAnaylticsService } from 'src/app/services/google-anayltics.service';
import { GoogleAnalyticsEvents, GoogleAnalyticsModules } from '../utils/constants';
import { ToasterService } from 'src/app/services/toaster.service';

@Component({
  selector: 'app-lng',
  templateUrl: './lng.component.html',
  styleUrls: ['./lng.component.scss'],
  encapsulation: ViewEncapsulation.None,
})
export class LngComponent {
  GoogleAnalyticsEvents = GoogleAnalyticsEvents;
  GoogleAnalyticsModules = GoogleAnalyticsModules;

  Lng: Lng = {
    fleet: '',
    isSkelton: false,
    lngDaysEditable: false,
    load: false,
    allSelect: false,
    download: true,
    date: new Date(),
    minDate: new Date(),
    maxDate: new Date(),
    lngData: [],
    allLngData: [],
    lngDaysYtdData: [],
    subpool: [],
    shipOwners: [],
    owners: [],
    vslClass: [],
    ship: [],
    selectMonth: 0,
    selectYear: 0,
    sortBy: '',
    sortValue: '',
    iRole: 0,
    selectDate: {
      month: 0,
      year: 0
    },
  }

  filters: Filters = {
    ship: [],
    shipOwners: [],
    vslClass: [],
    subpool: [],
    vslNumber: []
  }

  shipNames: any = [];
  subPools: any = [];
  shipOwners: any = [];
  vslClasses: any = [];
  subscription: Subscription;
  month: any;
  year: number;
  config: {
    width: "auto"
  }
  @Input() defaultActive: boolean;
  @Input() toggleVal: any;
  @Input() maxDate: Date;
  @Output() lngDatalist = new EventEmitter();
  @Output() showDropdownVal = new EventEmitter();
  @Output() toggleValue = new EventEmitter();
  lngData: any;
  showDropdown: boolean = false;
  getLngDatalist: any = [];
  newgetLngDatalist: any = [];
  lngOffhireCurrentMonth: any;
  lngOffhirePreviousMonth: any;
  latestYear: number;
  latestMonth: number;
  offHirelngData: any = [];
  offHirelngShipName: string = '';
  offHire: boolean = false;
  bunkerPriceHeaderName:string = 'Average bunker prices'
  columnHeader = [{ 'name': 'No.', 'width': '58px' },
  { 'name': 'From', 'width': '144px' },
  { 'name': 'To', 'width': '144px' },
  { 'name': 'Duration (days)', 'width': '152px' },
  { 'name': 'Reason', 'width': '367px' },
  { 'name': 'Remarks', 'width': '367px' }];
  monthToShow: string;
  yearToShow: number;
  isBunkerSectionOpen: boolean = false;
  getAvgBunkerPriceData: any = [];
  groupedByFiscalYear: [ string, AvgBunkerPriceData[] ][] = []
  lngSavingFormuladata: any = [];
  ownersLabel: any;  isScrolled: boolean = false;


  constructor(private _poolingPortalService: PoolingPortalService,
    private lngService: LngDataService, private _filterService: FiltersService,
    private _distributionDataService: DistributionDataService, private toasterService: ToasterService,
    private _googleAnaylticsService: GoogleAnaylticsService) { }

  ngOnInit() {
    console.log(this.toggleVal)
    this.Lng.isSkelton = true;
    this.shipNames = this._distributionDataService.filterdLngShipNames;
    this.subPools = this._distributionDataService.filteredLngSubPool;
    this.shipOwners = this._distributionDataService.filteredLngShipOwner;
    this.vslClasses = this._distributionDataService.filteredLngVslClass;
    this.month = this._distributionDataService.getMonth;
    this.monthToShow = this.maxDate.toLocaleString('en-US', { month: 'short' });    
    this.year = this._distributionDataService.getYear;
    this.yearToShow = this.maxDate.getFullYear();
    this.subscription = this._poolingPortalService.fleet$.subscribe(
      fleet => {
        this.Lng.fleet = fleet;
        this.Lng.isSkelton = true;
      })
    this.getOwnerList();
   
    this._distributionDataService.changeMonthYear.subscribe((res: any) => {
      console.log('lng changeMonthYear', res)
      if (Object.keys(res).length > 0) {
        let selectDate = new Date(res);
        let month = selectDate.getMonth() + 1;
        let year = selectDate.getFullYear();
        if((this.month !== month || this.year !== year) && this._distributionDataService.getSelectedPagetabVal() === "lng") {
          this.shipNames = [];
          this.shipOwners = [];
          this.subPools = [];
          this.vslClasses = [];
          this.filters.ship = [];
          this.filters.shipOwners = [];
          this.filters.subpool = [];
          this.filters.vslClass = [];
          this.month = selectDate.getMonth() + 1;
          this.year = selectDate.getFullYear();
          this.getOwnerList();
        }
        //User Story 106515: Updating the average bunker prices link to reflect the FY
        this.monthToShow = this.maxDate.toLocaleString('en-US', { month: 'short' });
        this.yearToShow = this.maxDate.getFullYear();
        if(month == 12){//december selected
          year++;
        }
        if(year < this.maxDate.getFullYear()){
          //show nov month and selected year
          this.monthToShow = 'Nov';
          this.yearToShow = year;
        }
      }
    });
  }

  getOwnerList() {
    this._distributionDataService.getOwnerList(this.Lng.fleet)
      .subscribe({
        next: (res: any) => {
          this.Lng.owners = res.data.getOwnersList.data.map((items: any) => ({ id: items?.value, name: items.label }))
          this.Lng.shipOwners = this._filterService.shipOwners(this.Lng.allLngData, this.filters, this.Lng.owners);
          this.ownersLabel = this.Lng.owners.reduce((op,inp)=>{
            let key = inp.id
            let value = inp.name
            op[key] = value
            return op
          },{})
          this.getLngDataset(this.year, this.month);
           this.lngSavingsFormula(this.year, this.month);
        }
      });
  }

  getLngDataset(latestYear: number, latestMonth: number) {
    this.latestYear = latestYear;
    this.latestMonth = latestMonth;
    let formData = {
      "month": this.month ? this.month : latestMonth,
      "year": this.year ? this.year : latestYear,
      "fleet": this.Lng.fleet
    };
    this.lngService.getLngData(formData).subscribe({
      next: (res: any) => {
        this.lngData = res?.data?.getLngData;
        this.Lng.allLngData = res?.data?.getLngData?.data;
        this.newgetLngDatalist = res?.data?.getLngData?.data;

        if (this._distributionDataService.filterdLngListdata?.length) {
          this.getLngDatalist = this._distributionDataService.filterdLngListdata;
          this.lngDatalist.emit(this._distributionDataService.filterdLngListdata);
        } else {
          this.getLngDatalist = res?.data?.getLngData?.data;
          this.lngDatalist.emit(this.getLngDatalist);
        }
        this.Lng.lngData = this._filterService.filterItems(this.Lng.allLngData, this.filters);
        this.applyFilter();
        this.refreshDropdownData();
      },
      error: (error: any) => {
        this.toasterService.openToast('Error', error)
      }
    })
  }

  public refreshDropdownData() {
    if (this.Lng.owners?.length) {
      if (this.filters.ship['selectedRecords']?.length) {
        this.filters.ship = this.filters.ship['selectedRecords'].map((record: any) => record.name);
      }
      if (this.filters.shipOwners['selectedRecords']?.length) {
        this.filters.shipOwners = this.filters.shipOwners['selectedRecords'].map((record: any) => record.id);
      }
      this.Lng.shipOwners = this._filterService.shipOwners(this.Lng.allLngData, this.filters, this.Lng.owners);
      this.Lng.shipOwners = this.Lng.shipOwners.filter((obj: any, index: any, self: any) => index === self.findIndex((x: any) => x.id === obj.id));
      console.log(this.Lng.shipOwners)
    }
    if (this.filters.subpool['selectedRecords']?.length) {
      this.filters.subpool = this.filters.subpool['selectedRecords'].map((record: any) => record.name);
    }
    if (this.filters.vslClass?.['selectedRecords']?.length) {
      this.filters.vslClass = this.filters.vslClass['selectedRecords'].map((record: any) => record.id);
    }
    if (!this.filters.vslClass?.length || this.filters.vslClass?.length === undefined) {
      this.filters.vslClass = [];
    }
    this.Lng.ship = this._filterService.ships(this.Lng.allLngData, this.filters);
    this.Lng.subpool = this._filterService.subpools(this.Lng.allLngData, this.filters);
    this.Lng.subpool = this.Lng.subpool.filter((obj: any, index: any, self: any) => index === self.findIndex((x: any) => x.id === obj.id));
    this.Lng.vslClass = this._filterService.vslClass(this.Lng.allLngData, this.filters);
    this.Lng.vslClass = this.Lng.vslClass.filter((obj: any, index: any, self: any) => index === self.findIndex((x: any) => x.id === obj.id));
  }

  public selectedValues(event: any, field: string) {
    this.filters[field] = event.selectedRecords?.map((items: any) => items?.id);
    this.filters['vslNumber'] = [];
    this.refreshDropdownData();
    this.Lng.lngData = this._filterService.filterItems(this.Lng.allLngData, this.filters);
    if (field === 'ship') {
      this.shipNames = this.filters[field]?.map((items: any) => ({ id: items, name: items }))
    } else if (field === 'subpool') {
      this.subPools = this.filters[field]?.map((items: any) => ({ id: items, name: items }))
    } else if (field === 'shipOwners') {
      this.shipOwners = this.filters[field]?.map((items: any) => ({ id: items, name: items }))
    } else if (field === 'vslClass') {
      this.vslClasses = this.filters[field]?.map((items: any) => ({ id: items, name: items }))
    }
    this.showDropdown = false;
    this.showDropdownVal.emit(this.showDropdown)
    this.applyFilter();
  }

  public resetDropdown(event: any, field: string) {
    if ((this.shipNames?.length && field === 'ship') || (this.subPools?.length && field === 'subpool') || (this.shipOwners?.length && field === 'shipOwners') || (this.vslClasses?.length && field === 'vslClass')) {
      this.filters[field] = [];
      this.Lng.lngData = this._filterService.filterItems(this.Lng.allLngData, this.filters);
      this.refreshDropdownData();
      if (field === 'ship') {
        this.shipNames = [];
      } else if (field === 'subpool') {
        this.subPools = [];
      } else if (field === 'shipOwners') {
        this.shipOwners = [];
      } else if (field === 'vslClass') {
        this.vslClasses = [];
      }
      this.showDropdown = false;
      this.showDropdownVal.emit(this.showDropdown)
      this.applyFilter();
    }
  }

  public resetActivate() {
    return (this.shipNames?.length || this.shipOwners?.length || this.subPools?.length || this.vslClasses?.length) ? true : false;
  }

  public resetAll() {
    let filters = ['ship', 'shipOwners', 'subpool', 'vslClass'];
    filters.forEach((it: any) => {
      this.filters[it] = [];
    });
    this.Lng.lngData = this._filterService.filterItems(this.Lng.allLngData, this.filters);
    this.refreshDropdownData();
    this.shipNames = [];
    this.shipOwners = [];
    this.subPools = [];
    this.vslClasses = [];
    this.showDropdown = false;
    this.showDropdownVal.emit(this.showDropdown)
    this.applyFilter();
  }

  applyFilter() {
    const selectedSubpools = (this.subPools || []).map((s: any) => s.id.toLowerCase().trim());
    const selectedShips = (this.shipNames || []).map((s: any) => s.name.toLowerCase().trim());
    const selectedOwners = (this.shipOwners || []).map((s: any) => s.id.toLowerCase().trim());
    const selectedClasses = (this.vslClasses || []).map((s: any) => s.id.toLowerCase().trim());
    this.getLngDatalist = this.newgetLngDatalist?.filter((items: any) =>
      (!selectedShips?.length || selectedShips?.includes(items?.vslName?.toLowerCase().trim())) &&
      (!selectedOwners?.length || selectedOwners?.includes(items?.vslOwner?.toLowerCase().trim())) &&
      (!selectedSubpools?.length || selectedSubpools?.includes(items?.subPool?.toLowerCase().trim())) &&
      (!selectedClasses?.length || selectedClasses?.includes((items?.vslClass || '').toLowerCase().trim()))
    )
    this.lngDatalist.emit({ filteredData: selectedSubpools?.length || selectedOwners?.length || selectedShips?.length || selectedClasses?.length ? this.getLngDatalist : [], allData: this.newgetLngDatalist });
    this._distributionDataService.filterdLngShipNames = this.shipNames?.length ? this.shipNames : [];
    this._distributionDataService.filteredLngShipOwner = this.shipOwners?.length ? this.shipOwners : [];
    this._distributionDataService.filteredLngSubPool = this.subPools?.length ? this.subPools : [];
    this._distributionDataService.filteredLngVslClass = this.vslClasses?.length ? this.vslClasses : [];
    this.getLngDatalist = this.getLngDatalist.map((items: any) => {
      if (this.toggleVal !== 'Monthly') {
        this.lngOffhireCurrentMonth = this.lngData?.hasOffHireinCurrentMonth?.some((x: any) => x?.toString().toLowerCase() == items?.vslCodeOwner?.toString().toLowerCase());
        this.lngOffhirePreviousMonth = this.lngData?.hasOffHireinPreviousMonth?.filter((x: any) =>
          !(this.lngData?.hasOffHireinCurrentMonth || [])?.includes(x));
        this.lngOffhirePreviousMonth = this.lngOffhirePreviousMonth?.some((x: any) => x?.toString().toLowerCase() == items?.vslCodeOwner?.toString().toLowerCase());
      } else {
        this.lngOffhireCurrentMonth = this.lngData?.hasOffHireinCurrentMonth?.some((x: any) => x?.toString().toLowerCase() == items?.vslCodeOwner?.toString().toLowerCase());
      }
      return items = {
        ...items,
        lngOffhireCurrentMonth: this.lngOffhireCurrentMonth,
        lngOffhirePreviousMonth: this.lngOffhirePreviousMonth
      }
    })
    console.log(this.getLngDatalist)
  }

  getYtdMonthlyVal(e: any) {
    this.toggleVal = e?.itemName;
    this.toggleValue.emit(this.toggleVal);
    this.applyFilter();
    this._distributionDataService.changeToggle.next(true);  
  }

  getOffHireLngData(data: any) {
    console.log(data)
    this.offHirelngShipName = data?.vslName;
    this.offHirelngData = [];
    let offHireobj = {
      "vslCode": data?.vslCode,
      "vslCodeOwner": data?.vslCodeOwner,
      "month": this.latestMonth,
      "year": this.latestYear,
      "toggleType": this.toggleVal
    }
    this._distributionDataService.getOffhireEventData(offHireobj).subscribe({
      next: (res: any) => {
        this.offHirelngData = res?.data?.getOffhireEvents?.data;
      },
      error: (error: any) => {
        this.toasterService.openToast('Error', error)
      }
    })
  }
  viewBunkerPrice(){
    this._googleAnaylticsService.triggerGTMEvent(GoogleAnalyticsEvents.VIEW_AVERAGE_BUNKER_PRICE,{module:GoogleAnalyticsModules.LNG});
    this.isBunkerSectionOpen = true;
      let payload = {
      "fleet": this.Lng.fleet,
      "month": this.latestMonth,
      "year": this.latestYear,
    }
    this._distributionDataService.viewBunkerPrice(payload);
    this._distributionDataService.$loadBunkerData.subscribe((res:any)=>{
      if(res){
        this.getAvgBunkerPriceData = res?.getAvgBunkerPriceData;
        this.groupedByFiscalYear = res?.groupedFiscalYear;
        console.log(this.getAvgBunkerPriceData)
        console.log(this.groupedByFiscalYear)
      }
    })
    
  }
  lngSavingsFormula(latestYear: number, latestMonth: number){
      let payload = {
      // "fleet": this.Lng.fleet,
      // "month": this.latestMonth,
      // "year": this.latestYear,
      "month": this.month ? this.month : latestMonth,
      "year": this.year ? this.year : latestYear,
      "fleet": this.Lng.fleet
    }
    this.lngService.getLngSavingsFormula(payload).subscribe({
       next: (res: any) => {
        console.log(res)
        this.lngSavingFormuladata = res?.data?.getFleetLevelLngSavings?.data[0];
       },
       error:(error:any)=>{
        this.toasterService.openToast('Error', error)
      }
    })
  }
  @HostListener('window:scroll', [])
  onWindowScroll() {
    const scrollY = window.pageYOffset || document.documentElement.scrollTop || document.body.scrollTop || 0;
    this.isScrolled = scrollY > 400;  
  }
  triggerGTMEvent(eventName: string) {
    this._googleAnaylticsService.triggerGTMEvent(eventName);
  }
}